import { NgModule } from '@angular/core';
import { SdvorAdditionalOptionsModule } from './components/additional-options';
import { SdvorCheckoutContactsModule } from './components/checkout-contacts';
import { SdvorCheckoutOrderSummaryModule } from './components/checkout-order-summary';
import { SdvorCheckoutPaymentModule } from './components/checkout-payment/checkout-payment.module';
import { SdvorCheckoutSwitchProfileModule } from './components/checkout-switch-profile';
import { SdvorReceiptAddressModule } from './components/receipt/receipt-address/receipt-address.module';
import { SdvorReceiptTypeTabsModule } from './components/receipt/receipt-type-tabs/receipt-type-tabs.module';
import { SdvorTimeSlotModule } from './components/time-slot';

@NgModule({
  imports: [
    SdvorCheckoutContactsModule,
    SdvorReceiptTypeTabsModule,
    SdvorReceiptAddressModule,
    SdvorTimeSlotModule,
    SdvorCheckoutPaymentModule,
    SdvorCheckoutSwitchProfileModule,
    SdvorAdditionalOptionsModule,
    SdvorCheckoutOrderSummaryModule,
  ],
})
export class CheckoutUiModule {}
